<template>
  <p-redirect-target />
</template>

<script>
import PRedirectTarget from '@/components/p-redirect-target';

export default {
  components: { PRedirectTarget },
};
</script>
